import type { App, Raw } from 'vue';
import { markRaw, readonly } from 'vue';

import { PLUGIN_KEY } from './providers';
import type { AuthAbstractService } from './services';
import { CookieService, SessionService } from './services';
import { RouterInitializerService } from './services/router-initializer.service';
import { createState } from './state';
import type { LoginFlowPlugin, PluginOptions } from './types';

export let auth: AuthAbstractService = Object.create(null);

export const state = createState();

export function createLoginFlow({ router, route, service, options }: PluginOptions): Raw<LoginFlowPlugin> {
  new RouterInitializerService(router).initialize(route);

  return markRaw({
    config: readonly(options),

    state: readonly(state),

    token() {
      return CookieService.GetSession();
    },

    login(fromRouteName?: string, redirectURI?: string) {
      if (fromRouteName) {
        SessionService.FromSession = fromRouteName;
      }

      return auth.redirectToLoginPage(redirectURI);
    },

    logout(redirectURI?: string) {
      CookieService.RemoveSession();

      SessionService.RemoveFromSession();

      return auth.redirectToLogoutPage(redirectURI);
    },

    logoutWithRedirect(redirectURI: string) {
      CookieService.RemoveSession();

      SessionService.RemoveFromSession();

      return auth.redirectToUri(redirectURI);
    },

    onError(clb) {
      state.onErrorClb = clb;
    },

    install(app: App): void {
      app.provide(PLUGIN_KEY, this);
      app.config.globalProperties['$redirectFlow'] = this;

      app.runWithContext(() => {
        auth = service instanceof Function ? service() : service;
      });
    },
  });
}
